import { useContext, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import RangeDateTimePicker from "../../../components/RangeDateTimePicker/RangeDateTimePicker";
import Icon from "./../../../components/Icon/Icon";
import PaginationComponent from "../../../components/Pagination/Pagination";
import Button from "./../../../components/Button/Button";
import HotelStars from "../../../helpers/HotelStars/HotelStars";
import Currency, {
  ConvertCurrency,
} from "./../../../helpers/Currency/Currency";
import { hotelUserContext } from "../../../context/UserContext/HotelUserContext/HotelUserContext";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import { isDateBiggerThan } from "../../../utils/validation/validation";
import { Block } from "../../../components/Block/Block";
import { convertRoleToPath, getISOStringDate } from "../../../utils";
import FAQSection from "./../../../components/FAQSection/FAQSection";
import moment from "jalali-moment";

const HotelsUser = () => {
  const navigate = useNavigate();

  const auth = useSelector((state) => state.auth);
  const loader = useSelector((state) => state.loader);

  const {
    hotels,
    selectedItem,
    setSelectedItem,
    filter,
    setFilter,
    from,
    setFrom,
    to,
    setTo,
    setShowSearchItems,
    pageCount,
    pageNumber,
    setPageNumber,
    total,
    handleSearchCitiesAndHotels,
    handleGetCityHotels,
  } = useContext(hotelUserContext);

  useEffect(() => {
    if (filter?.length >= 3) handleSearchCitiesAndHotels();
  }, [filter]);

  useEffect(() => {
    const handleClick = (e) => {
      if (document.getElementById("searchBox")?.contains(e.target)) {
        setShowSearchItems(true);
        setSelectedItem({});
      } else {
        setShowSearchItems(false);
      }
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  // price for room Per Night
  const daysDiffer = moment(to).diff(from, 'days')

  const handleSubmit = (event) => {
    event?.preventDefault();

    // Validation
    if (isEmpty(selectedItem))
      return toastErrorMessage("انتخاب شهر یا هتل الزامی است");

    if (isDateBiggerThan(from, to))
      return toastErrorMessage(
        "تاریخ شروع نمیتواند از تاریخ پایان بزرگتر باشد"
      );

    if (selectedItem.isHotel) {
      navigateToHotel(selectedItem.id);
    } else {
      handleGetCityHotels();
    }
  };

  useEffect(() => {
    if (!isEmpty(selectedItem)) handleGetCityHotels();
  }, [pageNumber]);

  const navigateToHotel = (id) => {
    navigate(
      `/${convertRoleToPath(auth.role)}/hotel/${id}?from=${getISOStringDate(
        from
      )}&to=${getISOStringDate(to)}`
    );
  };

  return (
    <>
      <SiteTitle title="هتل ها" />
      <div className="container">

        <div className="w-100 d-flex mb-5">
          <div className="bg-orange-dim p-1 rounded-pill d-flex p-2" style={{ width: 56, height: 56 }}>
            <img src="/assets/images/icons/hotels_icon.svg" alt="hotels" />
          </div>
          <div className="flex-grow-1 px-3 justify-around flex-column">
            <p className="text-soft">خدمات گردشگری /<span className="fw-bold text-dark"> هتل‌ها</span></p>
            {!isEmpty(hotels) ? (
              <h4> نتایج جستجو برای {selectedItem.fa_title}</h4>
            ) :
              <h4 className="mt-n4">رزرو هتل</h4>}
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="row g-3 mx-0">
            <div className="col-12 col-md-6 col-lg-4 p-3">
              <div
                className="position-relative bg-gray-dim rounded-pill border px-4 py-1 h-100"
                id="searchBox"
              >

                <div className="row align-items-center">
                  <div>
                    <Icon name="map-pin" className="fa-2x px-1" />
                  </div>
                  <div className="col">
                    <div>
                      <label
                        className="m-0 text-muted fs-14px"
                        htmlFor="citiesAndHotels"
                      >
                        نام هتل یا مقصد سفر
                      </label>
                      {isEmpty(selectedItem) ? (
                        <input
                          autoComplete="off"
                          autoFocus
                          type="text"
                          id="citiesAndHotels"
                          value={filter}
                          placeholder="شهر/هتل"
                          className="form-control border-0 shadow-none text-dark fw-bold p-0 bg-transparent"
                          onChange={(e) => setFilter(e.target.value)}
                        />
                      ) : (
                        <div>
                          <input
                            type="text"
                            value={
                              selectedItem?.isHotel
                                ? `${selectedItem.accommodation_type_title} ${selectedItem.fa_title}`
                                : `${selectedItem.fa_state_title}، ${selectedItem.fa_title}`
                            }
                            className="form-control border-0 shadow-none text-dark fw-bold p-0 bg-transparent"
                            readOnly
                          />
                        </div>
                      )}
                    </div>
                    <CitiesAndHotels />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 p-3">
              <div className="bg-gray-dim rounded-pill border px-4 py-1 h-100">
                <div className="row align-items-center">
                  <div>
                    <Icon name="calender-date" className="fa-2x px-1" />
                  </div>
                  <div className="col">
                    <label className="m-0 text-muted fs-14px" htmlFor="fromTo">
                      تاریخ ورود و خروج
                    </label>
                    <RangeDateTimePicker
                      initValue={{ from, to }}
                      onChange={(e) => {
                        setFrom(e.from);
                        setTo(e.to);
                      }}
                      placeholder="تاریخ ورود تا تاریخ خروج"
                      className="form-control border-0 shadow-none text-dark fw-bold p-0 m-0 bg-transparent mt-1"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <Button
                type="submit"
                className="btn-block h-100 py-3 py-md-3 rounded-pill"
                size="lg"
                color="primary"
                loading={loader}
              >
                جستجو
              </Button>
            </div>
          </div>
        </form>

        <Block className="mt-5">
          {!isEmpty(hotels) && (
            <>
              <h3 className="mb-5 text-dark">
                {total} هتل در {selectedItem.fa_title} یافت شد
              </h3>
              <div className="row g-2">
                {hotels?.map((item) => {
                  const min_price = item.minimum_room_price 
                  const min_price_off = item.minimum_room_price_off / daysDiffer
                  console.log('min_pricefof: ', typeof min_price_off)
                  return (
                    <div
                      className="mb-5 cursor-pointer col-12 col-lg-6 col-xxl-4"
                      key={item.id}
                      onClick={() => navigateToHotel(item.id)}
                    >
                      <div className="mb-4">
                        <img
                          src={item.cover_media?.media}
                          alt={item.cover_media?.title}
                          title={item.cover_media?.title}
                          className="rounded-pill"
                          loading="lazy"
                          style={{ height: 300, width: "100%" }}
                        />
                      </div>
                      <div className="d-flex flex-column justify-content-around gy-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <h3 className="text-dark">
                            {item.accommodation_title} {item.title}
                          </h3>
                          <div>
                            <HotelStars stars={item.stars} />
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <Icon name="map-pin" className="fa-2x" />
                          <span className="fs-17px">{item.address}</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <Icon name="spark" className="fa-2x" />
                          <span className="fs-17px">رزرو کاملاً آنلاین</span>
                        </div>
                      </div>
                      <div className="my-1">
                        {item.maximum_discount_percent > 0 ? (
                          <>
                            <div className="text-right">
                              <del className="text-muted">
                                <ConvertCurrency
                                  price={min_price}
                                />
                              </del>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center bg-orange text-white rounded-pill px-2 py-1">
                                <div>
                                  <Icon name="percent" className="fs-20px" />
                                </div>
                                <span className="ml-1 fs-12px d-md-none"> {/* hide from md+ */}
                                  {item.maximum_discount_percent} درصد تخفیف
                                </span>
                                <span className="ml-1 fs-19px d-none d-md-block"> {/* hide from md- */}
                                  {item.maximum_discount_percent} درصد تخفیف
                                </span>
                              </div>


                              <div className="text-right d-flex align-center">
                                <p className="fs-12px mr-2 text-dark m-0 d-flex">هرشب/یک بزرگسال</p>
                                <span className="fs-22px fw-bold text-dark">
                                  <ConvertCurrency
                                    price={item.minimum_room_price}
                                    per={daysDiffer}
                                  />
                                </span>
                                <span className="ml-1">
                                  <Currency isNormal />
                                </span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="text-right">
                            <span className="fa-2x text-dark">
                              <ConvertCurrency
                                price={item.minimum_room_price_off}
                                per={daysDiffer}
                              />
                            </span>
                            <span className="ml-2">
                              <Currency isNormal />
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
              <div className="d-flex justify-content-center">
                <PaginationComponent
                  pageCount={pageCount}
                  currentPage={pageNumber}
                  setPageNumber={setPageNumber}
                />
              </div>
            </>
          )}
        </Block>

        {/* Most visited cities */}
        {/* <div className="w-100 d-flex mt-3 mb-5">
          <div className="bg-orange-dim p-1 rounded-lg" style={{ width: 70, height: 70 }}>icon</div>
          <div className="flex-grow-1 px-3 align-center">
            <h4>پر طرفدار ترین مناطق</h4>
          </div>
        </div>
         */}

        <FAQSection />
      </div >
    </>
  );
};

export default HotelsUser;

const CitiesAndHotels = () => {
  const { showSearchItems, setShowSearchItems, citiesHotels, setSelectedItem } =
    useContext(hotelUserContext);

  if (
    (isEmpty(citiesHotels?.cities) && isEmpty(citiesHotels?.hotels)) ||
    !showSearchItems
  )
    return null;

  return (
    <div
      className="position-absolute bg-white border rounded overflow-auto cursor-pointer"
      style={{ maxHeight: 300, width: "100%", zIndex: 10 }}
    >
      {!isEmpty(citiesHotels?.cities) && (
        <>
          {citiesHotels?.cities?.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                setSelectedItem({ ...item, isHotel: false });
                setShowSearchItems(false);
              }}
              className="d-flex align-items-center justify-content-center py-2 border-bottom"
            >
              <div className="col-2">
                <Icon name="location" className="fa-2x" />
              </div>
              <div className="col">
                <h6>{item.fa_title}</h6>
                <span className="text-muted">استان {item.fa_state_title}</span>
              </div>
            </div>
          ))}
        </>
      )}
      {!isEmpty(citiesHotels?.hotels) && (
        <>
          {citiesHotels?.hotels?.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                setSelectedItem({ ...item, isHotel: true });
                setShowSearchItems(false);
              }}
              className="d-flex align-items-center justify-content-center py-2 border-bottom"
            >
              <div className="col-2">
                <Icon name="home" className="fa-2x" />
              </div>
              <div className="col">
                <span className="d-block font-weight-bold">
                  {item.accommodation_type_title} {item.fa_title}
                </span>
                <span className="text-muted">استان {item.fa_city_title}</span>
              </div>
              <div className="col-auto">
                <HotelStars stars={item.stars} />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
